<template>
    <footer class="footer">
        <img class="footer--banner" src="/netemosametemo/static/img/footer_cover.jpg" alt="９.１(土)テアトル新宿、ヒューマントラストシネマ有楽町、 渋谷シネクイントほか全国公開">
        <div class="footer--main">
            <figure class="text-center">
                <img src="/netemosametemo/static/img/footer_logo.png" alt="９.１(土)テアトル新宿、ヒューマントラストシネマ有楽町、 渋谷シネクイントほか全国公開">
            </figure>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'footer-tag',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue